import styled from 'styled-components';
import { spacing1x } from '../../styles/spacing.js';

var AdornmentContainer = styled.div.withConfig({
  displayName: "AdornmentContainer",
  componentId: "sc-1sski9h-0"
})(["&&{display:inline-block;margin-inline-end:", ";}"], spacing1x);

export { AdornmentContainer };
